import {UserInfoInputModel} from "./user-info-input.model";
import {CarInfoModel} from "../car-info/car-info.model";

export class UserInfoForUpdateTmpModel {

    // ユーザ情報
    user: UserInfoInputModel = new UserInfoInputModel;

    // SNS連携有無
    isSns: boolean;

    // お車情報
    cars: Array<CarInfoModel> = [];

    // オブジェクトの内容をコピーします
    public copy(obj: UserInfoForUpdateTmpModel) {
        if (obj) {
            this.user.copy(obj.user);
            this.cars = obj.cars.map(car =>
                new CarInfoModel().copy(car));
            this.isSns = obj.isSns;
        }
    }
    
    /** 初期状態を設定します */
    public initialize() {
        this.user.initialize();
    }
    
    /** 初期状態を解除します */
    public deinitialize() {
        this.user.deinitialize();
    }

}